export class RebalancingProposalMember {
  public userId!: string;
  public displayName!: string;
  public currentCases!: number;
  public capacity!: number;
  public utilizationPercent!: number;
}
